if not App.angularApp?
    return

MapSidebar = require('resources/assets/coffee/Core/MapSidebar').MapSidebar

App.angularApp.directive 'mfSlideToggle', () ->
    return {
        link: (scope, element, attrs) ->
            # We have to delay this so that it happens after ngOnDestroy from Angular components
            setTimeout () =>
                App.sidebar?.element.hide()
            , 0

            # This is CHEATING and it's bad. BUT I DON'T CARE.
            # Idk why you think it's bad....how else would you access it? ¯\_(ツ)_/¯ - akeenan
            App.angularSidebar = new MapSidebar App.map, element

            scope.$on '$destroy', () ->
                App.sidebar?.element.show()
    }
